import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";

export const Route = createFileRoute("/__authed/m/purchases")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_purchases")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: Outlet,
});
